module.exports = __webpack_public_path__ + "static/media/error-info-bg.a147a3ae.svg";